import { ExecutiveReportsSelectedOrganizationState } from '@pages/executive-reports-old/store/states/executive-reports-selected-organization.state';
import { ExecutiveReportsOrganizationNameOptionsState } from '@pages/executive-reports-old/store/states/executive-reports-organization-name-options.state';
import { ExecutiveReportsMetricTypeMappingsState } from '@pages/executive-reports-old/store/states/executive-reports-metric-type-mappings.state';
import { ExecutiveReportsSubOrganizationsState } from '@pages/executive-reports-old/store/states/executive-reports-sub-organizations.state';
import { ExecutiveReportsParticipantModulesState } from '@pages/executive-reports-old/store/states/executive-reports-participant-modules.state';
import { ExecutiveReportsSettingsState } from '@pages/executive-reports-old/store/states/executive-reports-settings.state';

export const executiveReportOldStates = [
  ExecutiveReportsSelectedOrganizationState,
  ExecutiveReportsOrganizationNameOptionsState,
  ExecutiveReportsMetricTypeMappingsState,
  ExecutiveReportsSubOrganizationsState,
  ExecutiveReportsParticipantModulesState,
  ExecutiveReportsSettingsState,
];
